import { render, staticRenderFns } from "./WristbandTable.vue?vue&type=template&id=482fd3a0&scoped=true"
import script from "./WristbandTable.vue?vue&type=script&lang=js"
export * from "./WristbandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fd3a0",
  null
  
)

export default component.exports